export const ENTER_KEY_MODE = 0;
export const EDIT_MODE = 1;
export const DONE_MODE = 2;
export const READ_ONLY_MODE = 3;
export const LOAD_MODE = 4;
export const SHOW_ERROR_MODE = 5;
export const PORTAL_MODE = 6;

// form name key word to identify specific forms
export const FormName_VFEF = "firemen";
export const FormName_Ownership = "ownership";
export const FormName_MemberShip = "membership";

//must match entries in the PDM.WFTargetType table!
export const Carrier = 2; //Members
export const OptiRiskFile = 17; //Optimus
export const NAICCarrier = 26; //Optimus.NAICCarrier